import _extends from '@babel/runtime-corejs3/helpers/extends';
import React, { useMemo } from 'react';
import { genID } from '../../utils/genID.js';

var red = 'rgb(255, 44, 85)';
var green = 'rgb(37, 244, 238)';
var black = 'rgb(15, 15, 15)';
var white = 'rgb(255, 255, 255)';
var r = '110';
var cy = '138';
var redProps = {
  r: r,
  cx: '352.5',
  cy: cy,
  strokeWidth: '0',
  className: 'tux-loading__red_animation'
};
var greenProps = {
  r: r,
  cx: '111',
  cy: cy,
  strokeWidth: '0',
  className: 'tux-loading__green_animation'
};

var _ref = /*#__PURE__*/React.createElement("rect", {
  width: "100%",
  height: "100%",
  fill: white
});

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: "100%",
  height: "100%",
  fill: white
});

var TUXLoading = function TUXLoading() {
  var uniqueId = useMemo(function () {
    return genID();
  }, []);
  var redHoleId = "tux-loading-red-hole-".concat(uniqueId);
  var greenHoleId = "tux-loading-green-hole-".concat(uniqueId);
  return /*#__PURE__*/React.createElement("div", {
    className: "w-48 h-48 box-border flex items-center justify-center"
  }, /*#__PURE__*/React.createElement("svg", {
    preserveAspectRatio: "none",
    viewBox: "0 0 463 276",
    width: "25",
    height: "15"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: redHoleId
  }, _ref, /*#__PURE__*/React.createElement("circle", _extends({}, redProps, {
    fill: black
  }))), /*#__PURE__*/React.createElement("mask", {
    id: greenHoleId
  }, _ref2, /*#__PURE__*/React.createElement("circle", _extends({}, greenProps, {
    fill: black
  })))), /*#__PURE__*/React.createElement("circle", _extends({}, redProps, {
    fill: black
  })), /*#__PURE__*/React.createElement("circle", _extends({
    mask: "url(#".concat(redHoleId, ")")
  }, greenProps, {
    fill: green
  })), /*#__PURE__*/React.createElement("circle", _extends({
    mask: "url(#".concat(greenHoleId, ")")
  }, redProps, {
    fill: red
  }))));
};

export { TUXLoading };
//# sourceMappingURL=TUXLoading.js.map
